import { render, staticRenderFns } from "./project-course.vue?vue&type=template&id=0b452942&"
import script from "./project-course.vue?vue&type=script&lang=js&"
export * from "./project-course.vue?vue&type=script&lang=js&"
import style0 from "./project-course.vue?vue&type=style&index=0&id=0b452942&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports